<template>
  <div>
    <VueLoadingButton
      :id="id"
      type="submit"
      :name="name"
      class="btn btn-primary py-2"
      style="font-size: 1rem; line-height: 1.5"
      :style="styleCustom"
      :class="className"
      :loading="isLoading"
      @click.native="onClick"
    >
      {{ title }}
    </VueLoadingButton>
  </div>
</template>
<script>
import VueLoadingButton from 'vue-loading-button'
export default {
  name: 'AppSelect',
  components: {
    VueLoadingButton,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    styleCustom: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    isValidate: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
      require: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    currentValue() {
      return this.value || ''
    },
    selectedItem() {
      if (this.nonObjectModel) {
        return this.value
      }
      return this.options.find((i) => i[this.keyValue] == this.value)
    },
  },
  methods: {
    onClick(data) {
      this.$emit('onClick', data)
    },
  },
}
</script>
